import { Loader } from "Components/General/Loader";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { CALLBACK_storeBimCollabAuthInfo } from "General/APIQueryParams";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const BIMCollabAuth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const authorize = async () => {
    try {
      // state looks like "projectId:<ID>"
      const state = searchParams.get("state");
      const projectId = state.split(":")[1];
      const params: CALLBACK_storeBimCollabAuthInfo = {
        code: searchParams.get("code"),
        state: state,
      };
      await API.newData(API_URL.CALLBACK.storeBimCollabAuthInfo(), null, params);
      navigate(`/project/${projectId}/settings`, { state: { tab: "sync" } });
    } catch (error) {
      navigate("/dashboard");
      throw error;
    }
  };

  useEffect(() => {
    authorize();
  }, [searchParams]);
  return <Loader style={{ marginTop: "15%" }} />;
};
